import {
  DEFAULT_VALUE_LABEL_LIST,
  // getXtenantId,
  transformMultiSelectFrontEndVal,
} from "../../../../../../../../utils/utils";

const getTransValuesForSelect = (val: any) =>
  transformMultiSelectFrontEndVal(DEFAULT_VALUE_LABEL_LIST, val)?.[0];

export const getTransPayload = (row: any) => {
  return {
    ...row,
    medicationId: getTransValuesForSelect(row?.medicationId),
    provider: getTransValuesForSelect(row?.provider),
    preferences: getTransValuesForSelect(row?.preferences),
    medicalCodes: transformMultiSelectFrontEndVal(
      DEFAULT_VALUE_LABEL_LIST,
      row?.medicalCodes
    ),
  };
};

// import { usePrescriptionPrintById } from "../../../../../../../../queries/patient-chart/order/prescription/use-get-prescription-print-by-uuid";
